import FormComponent from '../FormComponent';

class KeyPoints extends FormComponent {
	markup(value, data, titleMarkup) {
		return `
		${data?.hasSeperator ? `<div class="separator"></div>` : ''}
		<div class="lta-richtext ${data?.wrapperClasses ? `${data?.wrapperClasses}` : 'u-mb-5'} u-pt-0">
			<div class="${data?.innerClass ? `${data?.innerClass}` : 'u-mb-5'}">${titleMarkup}</div>
			<div 
				${
					data?.customStylingClass
						? ''
						: `class="rt-keypoint__secondary" style="--lta-theme--1: var(--color-lta-accent-bright-blue)"`
				}
			>
				${data?.subtitle ? `<h4>${data.subtitle}</h4>` : ''}
				${data?.instructionText ? `<p>${data.instructionText}</p>` : ''}
			</div>
    	</div>
	`;
	}
}

export default KeyPoints;
